module.exports = __webpack_public_path__ + "img/95B.adf55a1c.png";